import { render, staticRenderFns } from "./NavigationSubmenu.vue?vue&type=template&id=9a4456f2&"
import script from "./NavigationSubmenu.vue?vue&type=script&lang=js&"
export * from "./NavigationSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports